<script lang="ts">
  import type { Asset } from '@storyblok-types';
  import clsx from 'clsx';
  import { Text } from '@athena-lib/Text';
  import ImageOrVideo from '../ImageOrVideo.svelte';
  import { getFocalPointClasses } from '../shared/image-utils';
  import { getAssetMetaData } from '$lib/storyblok-assets';

  const {
    asset,
    zoomOnHover,
    showArtist,
  }: { asset: Asset; zoomOnHover: boolean; showArtist: boolean } = $props();
  const shouldZoomOnHover = $derived(
    zoomOnHover && 'transition-transform duration-[1500ms] ease-in-out hover:scale-125',
  );
  const assetClasses = 'absolute h-full w-full object-cover';
</script>

{#if asset}
  <div class="relative h-full w-full overflow-hidden">
    <ImageOrVideo
      {asset}
      videoClass={clsx(shouldZoomOnHover, assetClasses)}
      imageClass={clsx(assetClasses, shouldZoomOnHover)}
      innerImageClass={clsx(getFocalPointClasses(asset), assetClasses)}
    />
    {#if showArtist}
      <div class="absolute left-0 right-0 top-0 p-gutter">
        <Text color="light">
          {getAssetMetaData(asset).Artist}
        </Text>
      </div>
    {/if}
  </div>
{/if}
